import { assetUrl } from '../http/build-url';
import { asNumber, asString } from '../http/normalise';
import { ApiClient } from './client.dto';
import { Client, ClientStatus } from './client.model';

const CLIENT_STATUSES: ReadonlySet<string> = new Set<string>([
  'active',
  'suspended',
  'archived',
]);

function asClientStatus(value: unknown): ClientStatus {
  if (typeof value === 'string' && CLIENT_STATUSES.has(value)) {
    return value as ClientStatus;
  }
  return 'active';
}

export function mapClient(dto: ApiClient, storageBase: string): Client {
  const displayName =
    asString(dto.displayName) ?? asString(dto.legalName) ?? '';

  return {
    id: asString(dto.id) ?? '',
    legalName: asString(dto.legalName) ?? displayName,
    displayName,
    slug: asString(dto.slug),
    logoUrl: assetUrl(storageBase, dto.logoUrl),
    logoPath: asString(dto.logoUrl),
    primaryContactName: asString(dto.primaryContactName) ?? '',
    primaryContactEmail: asString(dto.primaryContactEmail) ?? '',
    phone: asString(dto.phone),
    vatNumber: asString(dto.vatNumber),
    industry: asString(dto.industry),
    internalNotes: asString(dto.internalNotes),
    status: asClientStatus(dto.status),
    eventCount: asNumber(dto.eventCount) ?? 0,
  };
}
